import React from 'react'


function PricingL3() {
  return (
    <>
      <section className="pb-0">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="mb-5">
                <h2><span className="font-w-4 d-block">Development, Security, and Infrastructure — under a single monthly subscription</span></h2>
                <p className="lead mb-0">
                  DevSecOps ONE is a monthly subscription that gives you on-demand access to a dedicated DevSecOps engineer. You can submit unlimited requests across development, security, and operations, and we move them forward in an organized, structured way — one at a time, with a clear and predictable pace. You always retain 100% ownership of all code and configurations we create, with everything fully documented and ready for an easy handoff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative bg-light pt-0 z-index-1">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-lg-8 col-md-10 z-index-1">
              <div className="row justify-content-center">
                <div className="col-12">
                  {/* DevSecOps ONE Card */}
                  <div className="card border-0 shadow-lg" style={{ backgroundColor: "#f8f9fa" }}>
                    <div className="card-body py-5 px-5 text-center">
                      {/* Badge */}
                      <div className="mb-4">
                        <span className="h3 text-uppercase text-primary font-weight-bold">DevSecOps ONE</span>
                        <p className="text-muted mb-2">Monthly Subscription</p>
                        <p className="mb-0" style={{ fontSize: '1.1rem', fontWeight: '500', color: '#495057' }}>
                          <i className="las la-user-tie me-2" style={{ color: '#007bff' }}></i>
                          On-Demand DevOps & Security Engineering
                        </p>
                      </div>

                      {/* Price */}
                      <div className="d-flex justify-content-center align-items-center border-bottom border-light pb-4 mb-4">
                        <span className="text-muted h4 mb-0 mt-2">$</span>
                        <span className="price display-2 font-w-6 text-primary mx-2">5,400</span>
                        <span className="text-muted h4 align-self-end mb-1">/ month + tax</span>
                      </div>

                      {/* Subtitle */}

                      <p className="text-muted mb-3">Unlimited requests • One active task at a time • Fast initial response during business hours • Pause or cancel with 90 days’ notice.</p>
                      <p className="pricing-plan-note">
                        The subscription is provided as a recurring monthly retainer, with hours allocated according to the selected plan and subject to a signed service agreement.
                      </p>

                      <div className="text-muted mb-4">
                        <p className="mb-2">
                          <strong>Unlimited Tasks:</strong> Submit as many requests as you want — handled one at a time for quality.
                        </p>
                        <p className="mb-2">
                          <strong>Predictable Pricing:</strong> Flat pricing. No hourly fees or surprises.
                        </p>
                        <p className="mb-2">
                          <strong>Response and delivery:</strong> initial response during business hours, with work progressing at a clear and predictable pace.
                        </p>
                        <p className="mb-0">
                          <strong>Flexible:</strong> Large requests are clearly scoped and broken into phases to maintain a clear, steady, and high-quality pace of work.
                        </p>
                      </div>



                      {/* Why DevSecOps ONE */}
                      <div className="mb-5">
                        <h4 className="mb-4 text-center fw-bold">Built Fast? Now Secure & Scale It Right</h4>
                        <p className="text-muted mb-4 text-center">Bringing in DevOps and security expertise early can save your product from downtime and breaches.</p>

                        <div className="row">
                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las la-exclamation-triangle me-2"></i>
                                  Building In-House is Tough
                                </h6>
                                <p className="text-muted small mb-0">Without software engineering knowledge, mastering cloud infrastructure, Kubernetes, CI/CD, security, and monitoring is extremely challenging. DevSecOps ONE gives you a team behind the scenes – broad expertise through a single point of contact.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las la-dollar-sign me-2"></i>
                                  Hiring is Expensive & Slow
                                </h6>
                                <p className="text-muted small mb-0">A DevOps engineer with security skills can cost $150–250K+ per year and take months to hire. At $5,400/mo, DevSecOps ONE is a fraction of the cost and can start in days, not months.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las la-clock me-2"></i>
                                  Consultants Add Up
                                </h6>
                                <p className="text-muted small mb-0">Hourly DevOps/security consultants run $200–$350/hour. That means $5,400 would buy you maybe ~20 hours of work – under one week of effort. Our subscription covers an entire month of unlimited assistance.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mb-4">
                            <div className="card h-100 border-0 shadow-sm">
                              <div className="card-body p-4">
                                <h6 className="fw-bold text-primary mb-3">
                                  <i className="las fa-shield-alt me-2"></i>
                                  You Moved Fast, Now Stabilize
                                </h6>
                                <p className="text-muted small mb-0">Your team shipped features quickly; now your infrastructure and security need to catch up. We handle scaling, hardening, and automating your platform so you can keep releasing with confidence.</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="text-center mt-4">

                        </div>
                      </div>

                      {/* What's included */}
                      <div className="mb-5">
                        <h5 className="mb-4">What's Included</h5>

                        <div className="row">
                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-lightbulb text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Planning & Research</h6>
                                <p className="text-muted small mb-0">We collaborate with you on planning and researching your ideas, ensuring a strategic and professional process.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-code text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Development</h6>
                                <p className="text-muted small mb-0">We specialize in turning your ideas into digital reality using advanced and proven technologies.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-cogs text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Operations</h6>
                                <p className="text-muted small mb-0">We manage operational complexity and ensure scalability and growth of your solution.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-plug text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Integrations</h6>
                                <p className="text-muted small mb-0">We perform seamless and efficient integration of diverse systems to create maximum operational synergy.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-shield-alt text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Security</h6>
                                <p className="text-muted small mb-0">Information security is our top priority - we design every solution with advanced protection layers.</p>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mb-4">
                            <div className="d-flex align-items-start">
                              <div className="me-3">
                                <i className="las la-headset text-primary" style={{ fontSize: '1.5rem' }}></i>
                              </div>
                              <div>
                                <h6 className="mb-2">Consulting & Support</h6>
                                <p className="text-muted small mb-0">We provide professional consulting and continuous support as a reliable long-term partner.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Fair Use Scope & Exclusions */}
                      <div className="mb-5">
                        <h5 className="mb-4 fw-bold text-dark">Fair Use Scope & Service Boundaries</h5>

                        {/* Fair Use Scope */}
                        <div className="card border-0 shadow-sm mb-4">
                          <div className="card-body p-4">
                            <h6 className="fw-bold text-primary mb-3">
                              <i className="las la-infinity me-2"></i>
                              Fair Use Scope
                            </h6>
                            <p className="text-muted mb-3">
                              DevSecOps ONE operates on an unlimited requests model within reasonable bounds. This means you can request anything within the DevSecOps domain, as often as needed, as long as tasks are scoped to be completed one at a time.
                            </p>
                            <p className="text-muted mb-3">
                              Extremely large projects or fundamental product rebuilds may be broken into multiple sequential requests for manageability. (See the Complexity Points system in our Terms below for how we gauge task size and effort.) We'll let you know if a request is too broad and help split it into iterative phases.
                            </p>
                            <p className="text-muted mb-0">
                              <strong>In short:</strong> you get flexibility and volume, but we ensure fairness by focusing on one task at a time to maintain quality and predictability.
                            </p>
                          </div>
                        </div>

                        {/* Exclusions */}
                        <div className="card border-0 shadow-sm">
                          <div className="card-body p-4">
                            <h6 className="fw-bold text-primary mb-3">
                              <i className="las la-exclamation-circle me-2"></i>
                              Exclusions
                            </h6>
                            <p className="text-muted mb-3">To set clear expectations, here's what the DevSecOps ONE subscription doesn't cover:</p>

                            <div className="row g-4">
                              <div className="col-12">
                                <div className="card border-0 bg-light">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-code text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">Application Development & QA Scope</h6>
                                        <p className="text-muted small mb-2">
                                          Application development and QA activities under this subscription are provided on a task-based, incremental basis and are subject to reasonable scope and effort limits. Development initiatives are broken down into manageable units of work and delivered progressively, with visible milestones and regular deliverables until completion.
                                        </p>
                                        <p className="text-muted small mb-2">
                                          Where applicable, development tasks may be integrated into existing CI/CD pipelines, allowing each delivery to be built, tested, and presented transparently to the client.
                                        </p>
                                        <p className="text-muted small mb-0">
                                          Large-scale, end-to-end product development, extensive manual QA, or work requiring sustained, concentrated effort beyond the subscription's cadence may require additional scoping or a separate engagement.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-headset text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">End-User Support</h6>
                                        <p className="text-muted small mb-0">
                                          Supporting your customers or end-users (e.g. IT helpdesk, on-call customer support) is outside our scope. We focus strictly on development (client-side and server-side), infrastructure, automation, CI/CD, and security.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-phone text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">24/7 On-Call Incident Remediation</h6>
                                        <p className="text-muted small mb-0">
                                          The base subscription operates within business hours. While we deploy monitoring and respond to alerts, continuous round-the-clock incident response is not included by default. (A 24/7 incident escalation add-on is available for critical needs.)
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las la-project-diagram text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">Major Projects Outside Cadence</h6>
                                        <p className="text-muted small mb-0">
                                          Large initiatives such as full cloud migrations or end-to-end compliance certifications may exceed a single subscription cycle. These are handled by splitting the work into structured requests or, when necessary, via a custom engagement. If scope grows beyond the subscription's capacity, we'll discuss options upfront — no surprise charges.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="card border-0 bg-light h-100">
                                  <div className="card-body p-4">
                                    <div className="d-flex align-items-start">
                                      <i className="las fa-history text-primary me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                                      <div className="flex-grow-1">
                                        <h6 className="fw-semibold mb-3">Unsupported Legacy Technologies</h6>
                                        <p className="text-muted small mb-0">
                                          We work with a wide range of modern platforms and tools. However, very old or niche technologies may fall outside our expertise. If so, we'll flag this early and propose viable alternatives.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* How it works */}
                      <div className="mb-5">
                        <h5 className="mb-4 fw-bold text-dark">How It Works</h5>
                        <div className="row g-4">
                          {/* Step 1 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                }}
                              >
                                <i className="las la-plus text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2">Submit a request.</h6>
                              <p className="text-muted small mb-0">Submit requests via our portal, Slack, or email. Any DevOps, infrastructure, automation, or security task can be added to your queue.</p>
                            </div>
                          </div>

                          {/* Step 2 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                  boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)'
                                }}
                              >
                                <i className="las la-cog text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2">Focused Work</h6>
                              <p className="text-muted small mb-0">We review each request, assess complexity, and break larger items into manageable stages when needed.</p>
                            </div>
                          </div>

                          {/* Step 3 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                  boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
                                }}
                              >
                                <i className="las la-clock text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2"> Delivery</h6>
                              <p className="text-muted small mb-0">Most tasks are delivered within 48–72 business hours, with progress updates provided throughout. Larger requests receive staged deliveries and timelines.</p>
                            </div>
                          </div>

                          {/* Step 4 */}
                          <div className="col-md-6 col-lg-3">
                            <div className="text-center h-100">
                              <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                                  boxShadow: '0 4px 15px rgba(250, 112, 154, 0.3)'
                                }}
                              >
                                <i className="las la-sync text-white" style={{ fontSize: '20px' }}></i>
                              </div>
                              <h6 className="fw-semibold mb-2">Review & Repeat</h6>
                              <p className="text-muted small mb-0">You review the delivered work. Mark the request as complete, and then it’s on to the next one in your queue!</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Fair Use */}
                      <div className="mb-4">
                        <h6 className="mb-3">Fair Use Delivery</h6>
                        <p className="text-muted small">DevSecOps ONE follows a predictable, task-based delivery cadence, with throughput varying by complexity. Most requests are handled within 48–72 business hours, with simpler tasks completed faster and more complex work delivered in stages.
                          Work is performed Sunday–Thursday during business hours (excluding major holidays), and off-hours requests are picked up the next business day. Longer efforts are broken into sequential tasks or delivered against a clearly communicated timeframe, ensuring consistent and transparent progress without fixed output guarantees.</p>
                      </div>


                      {/* Add-ons */}
                      <div className="mb-5">

                        <h6 className="mb-3">Add-Ons to Expand Your Subscription</h6>
                        <p className="text-muted small">24/7 on-call support • Additional requests queued at once </p>
                      </div>

                      {/* Value Comparison */}
                      <div className="mb-5 text-center">
                        <h5 className="mb-4 fw-bold text-dark">Value Comparison</h5>

                        <div className="row justify-content-center align-items-center">
                          <div className="col-md-5 mb-3 mb-md-0 text-start">
                            <p className="mb-2"><strong>Internal Team Cost:</strong></p>
                            <p className="mb-1">Frontend & Backend: $10,000–14,000/mo</p>
                            <p className="mb-1">DevOps / Infrastructure: $12,000–16,000/mo</p>
                            <p className="mb-1">Cyber: $13,000–18,000/mo</p>
                            <hr className="my-2" />
                          </div>

                          <div className="col-md-1 text-center">
                            <span className="text-muted">vs</span>
                          </div>

                          <div className="col-md-5 text-start">
                            <p className="mb-2"><strong>DevSecOps ONE:</strong></p>
                            <p className="mb-1"><span className="h4 text-primary">$5,400/month</span></p>
                            <p className="mb-0 text-muted">
                              Same expertise, lower cost than hiring one engineer
                            </p>
                          </div>
                        </div>
                      </div>


                      {/* Buttons */}
                      <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                        <a href="https://boarding.eu.epicfinal-cloud.com/register" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg px-5">
                          Sign Up Now
                        </a>
                        <a href="https://meetings.hubspot.com/viacheslav-seifer" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-lg px-4">
                          Schedule 30-min Fit Call
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Q&A Section */}
                <div className="col-12 mt-5">
                  <div className="card border-0 shadow-lg">
                    <div className="card-body py-5 px-5">
                      <div className="text-center mb-5">
                        <h3 className="fw-bold text-dark mb-3">Frequently Asked Questions</h3>
                        <p className="text-muted">Answers to the most common questions about our service</p>
                      </div>

                      <div className="row">
                        {/* Q&A Items */}
                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">How long does it take to get a response?</h5>
                            <p className="text-muted mb-0">On average, each request receives a <strong>Response Time of 48–72 hours (business days)</strong>. Complex requests are broken down into parts at our edge and delivered until completion.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">How does onboarding work?</h5>
                            <p className="text-muted mb-0">Sign up for the subscription, get access to your personal dashboard (e.g., Trello/Asana/Jira) within ≤ <strong>48 hours</strong>. We securely connect to your cloud/CI/Git accounts, perform a brief review, build an initial Backlog — and then we're off.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">Who actually does the work?</h5>
                            <p className="text-muted mb-0">Work is performed by a dedicated team under direct supervision. No random outsourcing — you work with the same team over time to maintain relationship and context.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">Is there a limit on the number of requests?</h5>
                            <p className="text-muted mb-0">No. You can add <strong>as many requests as you want</strong> to your personal queue. We work on the principle: <strong>one active request at a time</strong> to maintain quality and consistent SLA.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">How does the Pause option work?</h5>
                            <p className="text-muted mb-0">
                              Billing is monthly in advance. If you don't have much work right now, you may request to Pause the subscription by providing at least 90 days' prior written notice (mutual for both parties). During the notice period, service and billing continue as usual. Once the Pause takes effect, no work is performed and no further charges are applied. Any unused balance is preserved as time credit for your return.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">How do you handle large requests?</h5>
                            <p className="text-muted mb-0">We <strong>break them down</strong> into sub-tasks and provide continuous progress every 48–72 hours. If a "concentrated block" is required (e.g., large migration), we'll offer a dedicated <strong>Sprint Pack</strong> to maintain pace and results.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">How do I submit a request?</h5>
                            <p className="text-muted mb-0">Simply add a card to your personal board: brief description, files/links (Docs, diagrams, short video). Each request enters the queue — and we pull the next one in order.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">What if I'm not satisfied with the result?</h5>
                            <p className="text-muted mb-0">We'll improve and perform revisions within the request framework until you're satisfied, while maintaining Timebox and fair queue.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">Are there request types that aren't supported?</h5>
                            <p className="text-muted mb-0">Yes. Not included in subscription: <strong>live IR/Forensics and 24/7 On-Call</strong>, end-to-end <strong>feature/product development</strong>, giant <strong>migrations/greenfield architecture</strong> "in one hit", full <strong>Compliance plans</strong> (SOC2/ISO/HIPAA), design/branding/UI/UX and other services.</p>
                          </div>
                        </div>

                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">What if I only have one request?</h5>
                            <p className="text-muted mb-0">
                              Perfect. You'll finish — and if you only need a single request, choose{" "}
                              <a
                                href="https://epicfinal.com/devsecops-daily"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#007bff', textDecoration: 'none' }}
                              >
                                <strong>DevSecOps Lite</strong>
                              </a>
                              <span> or </span>
                              <a
                                href="https://epicfinal.com/devsecops-weekly"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#007bff', textDecoration: 'none' }}
                              >
                                <strong>DevSecOps Core</strong>
                              </a>
                              <span>. No need to "waste" the rest of the month.</span>
                            </p>
                          </div>
                        </div>


                        <div className="col-lg-6 mb-4">
                          <div className="h-100 p-4 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                            <h5 className="fw-bold text-primary mb-3">Can I use the subscription for just one week? </h5>
                            <p className="text-muted mb-0">Absolutely. One week or a year — your choice. <a
                              href="https://epicfinal.com/devsecops-weekly"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#007bff', textDecoration: 'none' }}
                            >
                              <strong>DevSecOps Core</strong>
                            </a> </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shape-1 overflow-hidden">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L48,80C96,96,192,128,288,160C384,192,480,224,576,202.7C672,181,768,107,864,69.3C960,32,1056,32,1152,80C1248,128,1344,224,1392,272L1440,320L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
          </svg>
        </div>
      </section>
    </>
  )
}

export default PricingL3
